export const Education = {
  "label": "Education",
  "value": [
    {
      "code": "HD-0500.3000",
      "keyword": "Homeschooling"
    },
    {
      "code": "HD-0500.5000-050",
      "keyword": "Alternative Schools"
    },
    {
      "code": "HD-1200",
      "keyword": "Boards of Education"
    },
    {
      "code": "HD-1800.1800-200",
      "keyword": "Early Head Start Sites"
    },
    {
      "code": "HD-1800.3000-350",
      "keyword": "Head Start Sites"
    },
    {
      "code": "HD-1800.6500",
      "keyword": "Preschools"
    },
    {
      "code": "HD-1800.8000",
      "keyword": "School Readiness Programs"
    },
    {
      "code": "HD-6000.1300",
      "keyword": "Colleges\/Universities"
    },
    {
      "code": "HD-6000.9000",
      "keyword": "Technical\/Trade Schools"
    },
    {
      "code": "HD-6500",
      "keyword": "Private Schools"
    },
    {
      "code": "HD-8000",
      "keyword": "Public Schools"
    },
    {
      "code": "HH",
      "keyword": "Educational Programs"
    },
    {
      "code": "HH-0500.1500",
      "keyword": "Citizenship Education"
    },
    {
      "code": "HH-0500.1560",
      "keyword": "College\/University Extension Programs"
    },
    {
      "code": "HH-0500.1600",
      "keyword": "Continuing Education"
    },
    {
      "code": "HH-0500.1830",
      "keyword": "Cooperative Extension Service Education Programs"
    },
    {
      "code": "HH-0500.2500-250",
      "keyword": "GED\/High School Equivalency Test Instruction"
    },
    {
      "code": "HH-0500.8000-150",
      "keyword": "English as a Second Language"
    },
    {
      "code": "HH-0500.8000-800",
      "keyword": "Spanish as a Second Language"
    },
    {
      "code": "HH-4500",
      "keyword": "Literacy Programs"
    },
    {
      "code": "HH-8000",
      "keyword": "Special Education"
    },
    {
      "code": "HH-8300",
      "keyword": "Summer School Programs"
    },
    {
      "code": "HH-9000.9000",
      "keyword": "Vocational\/Trade High Schools"
    },
    {
      "code": "HL",
      "keyword": "Educational Support Services"
    },
    {
      "code": "HL-2000.2050",
      "keyword": "Functional Behavioral Assessment"
    },
    {
      "code": "HL-2500.1500",
      "keyword": "College\/University Entrance Support"
    },
    {
      "code": "HL-8000.1830",
      "keyword": "Educational Grants"
    },
    {
      "code": "HL-8000.8000",
      "keyword": "Scholarships"
    },
    {
      "code": "HL-8000.8100",
      "keyword": "Student Loans"
    },
    {
      "code": "HL-8120.1800",
      "keyword": "Elementary\/Secondary School Registration Offices"
    },
    {
      "code": "HL-8120.7800",
      "keyword": "School Supplies"
    },
    {
      "code": "HL-8120.7950",
      "keyword": "Student Counseling Services"
    },
    {
      "code": "HL-8120.7980",
      "keyword": "Student Disability Services"
    },
    {
      "code": "HL-8120.8200",
      "keyword": "Student Transportation Services"
    },
    {
      "code": "HL-8700",
      "keyword": "Tutoring Services"
    },
    {
      "code": "HL-9000",
      "keyword": "Virtual Learning Assistance Hubs"
    },
    {
      "code": "JR-8200.1980",
      "keyword": "Farm Safety Education"
    },
    {
      "code": "JR-8200.2100",
      "keyword": "Firearm Safety Education"
    },
    {
      "code": "JR-8200.3400",
      "keyword": "Internet Safety Education"
    },
    {
      "code": "JR-8200.6500",
      "keyword": "Personal Safety Education"
    },
    {
      "code": "JR-8200.8500-180",
      "keyword": "Driving Safety Education"
    },
    {
      "code": "JR-8200.9500-450",
      "keyword": "Lifeguard Training"
    },
    {
      "code": "JR-8400.1500",
      "keyword": "Child Passenger Safety Seats"
    },
    {
      "code": "JR-8200.1500-100",
      "keyword": "Babysitting Instruction"
    },
    {
      "code": "JR-8200.1500-150",
      "keyword": "Child Care Provider Training"
    },
    {
      "code": "PH-6200.4600",
      "keyword": "Life Skills Education"
    },
    {
      "code": "PH-6200.7000",
      "keyword": "Relationship Workshops"
    },
    {
      "code": "PH-6100",
      "keyword": "Parenting Education"
    },
    {
      "code": "LR-1000",
      "keyword": "Braille Instruction"
    },
    {
      "code": "LR-8000.0500-800",
      "keyword": "Sign Language Instruction"
    },
    {
      "code": "LR-8000.8000",
      "keyword": "Speech and Language Pathology"
    },
    {
      "code": "TJ-4400.6500",
      "keyword": "Public Libraries"
    },
    {
      "code": "TJ-4400.8100-180",
      "keyword": "Disability Related Libraries"
    },
    {
      "code": "TJ-4500.4500-750",
      "keyword": "Recordings for the Blind and Dyslexic"
    },
    {
      "code": "TJ-4500.8300-100",
      "keyword": "Braille Materials\/Collections"
    },
    {
      "code": "TJ-4500.8300-450",
      "keyword": "Large Print Materials\/Collections"
    },
  ]
}
